import styled from "styled-components";
import { getNewLookTokens } from "common/NewLook/tokens.ts";

/**
 * New look: an antd table inside a flush `Panel`. Rows are 56px with
 * hairlines between them and a faint hover; the outer columns line up with
 * the panel title (20px) and the row menus with the header's controls. Column
 * headers keep the shared micro style from common/Table.
 */
const PanelTable = styled.div`
  position: relative;
  min-width: 0;
  .ant-table-wrapper .ant-table {
    background: transparent;
  }
  .ant-table-wrapper .ant-table-tbody > tr > td {
    height: 60px;
    padding: 8px 12px;
    transition: background-color 120ms;
  }
  .ant-table-wrapper .ant-table-thead > tr > th {
    padding: 10px 12px;
    white-space: nowrap;
  }
  .ant-table-wrapper .ant-table-thead > tr > th:first-child,
  .ant-table-wrapper .ant-table-tbody > tr > td:first-child {
    padding-left: 20px;
  }
  .ant-table-wrapper .ant-table-thead > tr > th:last-child,
  .ant-table-wrapper .ant-table-tbody > tr > td:last-child {
    padding-right: 16px;
  }
  && .ant-table-wrapper .ant-table-tbody > tr.ant-table-row:hover > td,
  &&
    .ant-table-wrapper
    .ant-table-tbody
    .ant-table-row
    > .ant-table-cell-row-hover {
    background: ${(p) => getNewLookTokens(p.theme).rowHover} !important;
  }
  .ant-table-wrapper .ant-table-tbody > tr.ant-table-row:focus-visible {
    outline: none;
  }
  .ant-table-wrapper .ant-table-tbody > tr.ant-table-row:focus-visible > td {
    box-shadow: inset 0 2px 0 ${(p) => getNewLookTokens(p.theme).focus},
      inset 0 -2px 0 ${(p) => getNewLookTokens(p.theme).focus};
  }
  .ant-table-wrapper
    .ant-table-tbody
    > tr.ant-table-row:focus-visible
    > td:first-child {
    box-shadow: inset 2px 2px 0 ${(p) => getNewLookTokens(p.theme).focus},
      inset 0 -2px 0 ${(p) => getNewLookTokens(p.theme).focus};
  }
  .ant-table-wrapper
    .ant-table-tbody
    > tr.ant-table-row:focus-visible
    > td:last-child {
    box-shadow: inset -2px 2px 0 ${(p) => getNewLookTokens(p.theme).focus},
      inset 0 -2px 0 ${(p) => getNewLookTokens(p.theme).focus};
  }
  .ant-table-wrapper .ant-table-cell.ant-table-selection-column {
    width: 52px;
    min-width: 52px;
  }
  /* The empty state sits in the panel, not in a bordered table cell. */
  .ant-table-wrapper .ant-table-tbody > tr.ant-table-placeholder > td {
    height: auto;
    padding: 0;
    border-bottom: 0;
    background: transparent !important;
  }
  .ant-table-wrapper .ant-table-tbody > tr.ant-table-placeholder:hover > td {
    background: transparent !important;
  }
  .ant-table-wrapper .ant-table-pagination.ant-pagination {
    margin: 0;
    padding: 12px 16px;
    border-top: 1px solid ${(p) => getNewLookTokens(p.theme).hairline};
  }
  /* "87 users" next to the pagination, on the panel's content edge. */
  .ant-table-wrapper + p {
    margin-left: 20px;
    color: ${(p) => getNewLookTokens(p.theme).muted};
    font-size: 12px;
    font-variant-numeric: tabular-nums;
  }
  /* Sort arrows sit right after the column title (on the left of it for
     right-aligned figure columns). */
  .ant-table-wrapper .ant-table-column-sorters {
    justify-content: flex-start;
    gap: 4px;
    .ant-table-column-title {
      flex: none;
    }
  }
  .ant-table-wrapper
    .ant-table-thead
    th[style*="right"]
    .ant-table-column-sorters,
  .ant-table-wrapper
    .ant-table-thead
    th.ant-table-cell-align-right
    .ant-table-column-sorters {
    justify-content: flex-end;
  }
`;

export default PanelTable;
